// extracted by mini-css-extract-plugin
module.exports = {"block":"FilterIntegratedButtonsTemplate_block__xj22H","list":"FilterIntegratedButtonsTemplate_list__FVdzZ","button":"FilterIntegratedButtonsTemplate_button__TBw5b"};